import React from 'react';

const InfoFixeLine = (Data, label1, label2) => {
  if (Data.device) {
    return (
      <div className="form-group">
        <label>{label1}</label>
        <div className="form-control">{Data.device}</div>
        <label>{label2}</label>
        <div className="form-control">{Data.mac_address}</div>
      </div>
    )
  }
  return;
}

export default InfoFixeLine;



// WEBPACK FOOTER //
// ./src/components/MyServices/InfosFixeLine.js